import React from 'react';

import { useGetSupplier } from '~/hooks/apis/tours/useTourSuppliers';

import { TourService } from '~/types/tours/costPrice';

interface Props {
  service: TourService;
}

/**
 * Names a service by its supplier. A synced service is named after the tour, which the page
 * already shows, so only the supplier tells services apart; the full name is on hover.
 */
export default function TourServiceOptionLabel({ service }: Props) {
  const { data: supplier, error } = useGetSupplier(service.supplierId);
  const supplierName = supplier?.name ?? (error ? 'Supplier unavailable' : 'Loading supplier…');

  return (
    <span title={`${service.name} (${service.kind})`}>
      {supplierName}
      {service.kind !== 'Tour' && ` (${service.kind})`}
    </span>
  );
}
